module.exports = __webpack_public_path__ + "media/images/icons/icons_large/29_twobirds-33bbf9ab5fe9922f2d713b3aa78b08ee.png";